/** The C64's sixteen colours, Colodore measurements (docs/spec/04 §2). */

export const C64: readonly string[] = [
  '#000000', // 0 black
  '#ffffff', // 1 white
  '#813338', // 2 red
  '#75cec8', // 3 cyan
  '#8e3c97', // 4 purple
  '#56ac4d', // 5 green
  '#2e2c9b', // 6 blue
  '#edf171', // 7 yellow
  '#8e5029', // 8 orange
  '#553800', // 9 brown
  '#c46c71', // 10 light red
  '#4a4a4a', // 11 dark grey
  '#7b7b7b', // 12 grey
  '#a9ff9f', // 13 light green
  '#706deb', // 14 light blue
  '#b2b2b2', // 15 light grey
];

export const COLOUR_NAMES: readonly string[] = [
  'BLACK', 'WHITE', 'RED', 'CYAN', 'PURPLE', 'GREEN', 'BLUE', 'YELLOW',
  'ORANGE', 'BROWN', 'LT RED', 'DK GREY', 'GREY', 'LT GREEN', 'LT BLUE', 'LT GREY',
];

export const BLACK = 0;
export const WHITE = 1;
export const RED = 2;
export const CYAN = 3;
export const PURPLE = 4;
export const GREEN = 5;
export const BLUE = 6;
export const YELLOW = 7;
export const ORANGE = 8;
export const BROWN = 9;
export const LIGHT_RED = 10;
export const DARK_GREY = 11;
export const GREY = 12;
export const LIGHT_GREEN = 13;
export const LIGHT_BLUE = 14;
export const LIGHT_GREY = 15;

export function c64(index: number): string {
  return C64[index & 15] ?? '#000000';
}

/** [r, g, b] 0-255. */
export function rgb(index: number): [number, number, number] {
  const hex = c64(index);
  return [Number.parseInt(hex.slice(1, 3), 16), Number.parseInt(hex.slice(3, 5), 16), Number.parseInt(hex.slice(5, 7), 16)];
}

/** The fixed scheme used for every cave in High contrast mode (docs/spec/07 §5). */
export const HIGH_CONTRAST: readonly [number, number, number] = [ORANGE, LIGHT_GREY, WHITE];

/** Keys and doors carry their own colours, like hardware sprites (04 §2): gold, jade, ruby. */
export const KEY_COLOURS: readonly number[] = [YELLOW, LIGHT_GREEN, LIGHT_RED];
